import { useEffect, useState, useRef, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Stack, Button, Tooltip, IconButton, Backdrop, CircularProgress } from '@mui/material';
import { DataGrid, jaJP } from '@mui/x-data-grid';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PostAddIcon from "@mui/icons-material/PostAdd";
import axios from "axios";
import dayjs from 'dayjs';
import { API } from "./constantsFront";
import { PAGE_SIZE, MSG } from "./constantsFront";
import { MsgContext } from "../../App";
import { Publish } from "@mui/icons-material";


/**
 * プライバシーポリシー一覧
 * @returns
 */

function G0241PrivacyPolicyList() {
  const [pageSize, setPageSize] = useState(PAGE_SIZE); 	//ページサイズ
  const [isLoading, setIsLoading] = useState(false);  	// Loading
  const { msg, setMsg } = useContext(MsgContext);				// エラーメッセージ
  const [rows, setRows] = useState([]);

  let body = { authKey: API.API_KEY };
  const navigate = useNavigate();

  // useEffect初回読み込みフラグ
  const refIsFirst = useRef(true);
  //初回表示
  useEffect(() => {
    //初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    displayData()

    //初回読込フラグをfalseにセット
    refIsFirst.current = false;
  }, [])

  //表示データ用
  function displayData() {
    // Loading
    setIsLoading(true);
    //公開データのID取得後にデータの表示形式を整える
    publishCheck().then(async (publishId) => {
      //データ一覧取得
      let res = await axios.post("/m_privacy_policy/select/auth", body);
      if (res.status !== 200) {
        return;
      }
      //表示形式を整える
      let privacyList = res.data.privacyList;
      console.log(privacyList);
      let rowData = [];
      for (let i in privacyList) {
        rowData.push({
          id: privacyList[i].privacy_policy_id,
          publish_date: dayjs(privacyList[i].publish_date).format("YYYY-MM-DD HH:mm"),
          content: privacyList[i].content,
          //公開中のデータの場合は「公開中」と表示する。
          publish: privacyList[i].privacy_policy_id == publishId ? "公開中" : null
        })
      }
      setRows(rowData);
    }).catch(error => {
      console.log('error:', error.message);
      setMsg(MSG.EXCEPTION);
    }).finally(() => {
      // Loading
      setIsLoading(false);
    })
  }

  //グリッドヘッダー
  const columns = [
    { field: 'publish', headerName: '公開状態', width: 100 },
    { field: 'publish_date', headerName: '公開日時', width: 200 },
    { field: 'content', headerName: '内容', flex: 1 },
    {
      field: 'add', headerName: '', sortable: false, disableClickEventBubbling: true, width: 50,
      renderCell: (params) =>
        <Tooltip title="複製" arrow>
          <Link to={"/G0242PrivacyPolicyEdit"} state={{ ID: params.id, CopyAdd: -1 }}>
            <IconButton>
              <PostAddIcon />
            </IconButton>
          </Link>
        </Tooltip>
    },
    {
      field: 'edit', headerName: '', sortable: false, disableClickEventBubbling: true, width: 50,
      renderCell: (params) =>
        <Tooltip title="編集" arrow>
          <IconButton onClick={() => updatePrivacyPolicy(params.id)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
    },
    {
      field: 'delete', headerName: '', sortable: false, disableClickEventBubbling: true, width: 50,
      renderCell: (params) =>
        <Tooltip title="削除" arrow>
          <IconButton onClick={() => deletePrivacyPolicy(params.id)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
    }
  ];

  //プライバシーポリシー 公開データのIDを渡す
  async function publishCheck() {
    try {
      console.log("プライバシーポリシー 公開データID取得開始");
      let res = await axios.post("/m_privacy_policy/select/publish/auth", body)
      if (res.status !== 200) {
        setMsg("データを正常に取得できませんでした。");
        return;
      } else {  //正常時
        console.log(res.data.privacy);
        //現在公開されているデータのID
        let publish_id = res.data.privacy[0].privacy_policy_id;
        return publish_id;
      }
    } catch (error) {
      console.log("プライバシーポリシー 公開データID取得完了(例外)");
      console.log("error : " + error.message);
      setMsg(MSG.EXCEPTION);
    }
  }

  //プライバシーポリシー 編集処理
  async function updatePrivacyPolicy(select_id) {
    try {
      //公開データID取得
      let publish_id = await publishCheck();
      //操作対象データが現在の公開データならメッセージ表示
      if (select_id == publish_id) {
        setMsg("選択されたデータは現在公開中のため編集できません。\n「複製」から差分を作成してください。");
        return;
      }
      //現在公開されているデータでないなら編集可
      navigate("/G0242PrivacyPolicyEdit", { state: { ID: select_id } });
    } catch (error) {
      console.log("プライバシーポリシー 編集完了(例外)");
      console.log("error : " + error.message);
      setMsg(MSG.EXCEPTION);
    }
  }

  //プライバシーポリシー 削除処理
  async function deletePrivacyPolicy(select_id) {
    try {
      if (window.confirm("削除してもよろしいですか？")) {
        //公開データid取得
        let publish_id = await publishCheck();
        //操作対象データが現在の公開データならメッセージ表示
        if (select_id == publish_id) {
          setMsg("選択されたデータは現在公開中のため削除できません。");
          return;
        }

        //現在の公開データ出ない場合削除開始
        console.log("プライバシーポリシー 削除開始");

        //DBへの送信データ格納
        let csletr = [];
        csletr.push(select_id);
        let arrStr = [];
        arrStr = JSON.stringify(csletr);
        body.arrStr = arrStr;

        //DB実行
        let res = await axios.post("/m_privacy_policy/delete/auth", body);
        //statusチェック
        if (res.status !== 200) {
          console.log("削除終了(失敗)");
          setMsg("プライバシーポリシー 削除に失敗しました。");
          return;
        } else {
          console.log("削除終了(成功)");
          return window.location.reload();
        }
      } else {
        console.log("プライバシーポリシー 削除(キャンセル)");
      }
    } catch (error) {
      console.log("プライバシーポリシー 削除完了(例外)");
      console.log("error : " + error.message);
      setMsg(MSG.EXCEPTION);
    }
  }

  return (
    <>
      <div class="mainLinkMenu"></div>
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">
              <Container maxWidth="lg">

                <Backdrop open={isLoading}
                  sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                  <CircularProgress />
                </Backdrop>

                <Stack spacing={2}>
                  <h1>プライバシーポリシー 一覧</h1>

                  <div style={{ width: '100%' }}>
                    <DataGrid
                      className='DataGrid'
                      columns={columns}
                      rows={rows}
                      autoHeight
                      disableSelectionOnClick
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                      pagination
                      localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                    />
                  </div>
                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  )
};

export default G0241PrivacyPolicyList;